import { apiClient } from './authApi';
import { AuditLog, AuditLogParams, AuditLogListResponse } from '../../types/audit';

export const auditApi = {
  getAll: async (params?: AuditLogParams): Promise<AuditLogListResponse> => {
    const response = await apiClient.get('/audit', { params });
    return {
      data: response.data.data,
      total: response.data.pagination?.total ?? response.data.data.length,
      page: response.data.pagination?.page ?? params?.page ?? 1,
      limit: response.data.pagination?.limit ?? params?.limit ?? 10,
    };
  },

  getActions: async (): Promise<string[]> => {
    const response = await apiClient.get('/audit/actions');
    return response.data.data;
  },

  getByResource: async (resourceType: string, resourceId: string): Promise<AuditLog[]> => {
    const response = await apiClient.get(`/audit/${resourceType}/${resourceId}`);
    return response.data.data;
  }
};
